window.addEventListener('load', function () {
    
    /* Fix desktop navbar dropdowns */

    var dropdowns = document.querySelectorAll('#navbarNavDropdown .dropdown-toggle');
    dropdowns.forEach(function (dropdownElement) {
        dropdownElement.addEventListener('click', function (event) {
            event.preventDefault();

            var targetDropdownMenu = this.nextElementSibling;
            document.querySelectorAll('#navbarNavDropdown .dropdown-menu.show').forEach(function (openMenu) {
                if (openMenu !== targetDropdownMenu) {
                    new bootstrap.Dropdown(openMenu.previousElementSibling).hide();
                    // hide function above should do this but doesn't appear to
                    openMenu.previousElementSibling.classList.remove('show');
                }
            });

            var dropdown = new bootstrap.Dropdown(dropdownElement);
            dropdown.toggle();
        });
    });

    /* Home page hero slider */

    var homeHeroSliderElement = document.querySelector('#home-hero-slider');
    if (homeHeroSliderElement) {
        var homeHeroSlider = new Splide(homeHeroSliderElement, {
            type: 'fade',
            perPage: 1,
            focus: 0,
            autoplay: true,
            rewind: true,
            interval: 5000,
            omitEnd: true,
            arrows: false,
            flickPower: 120
        });

        homeHeroSlider.mount();
    }

    /* Donate mega menu */

    var donationCampaignsSlider = new Splide('.donation-campaigns-slider.splide', {
        perPage: 1,
        focus: 0,
        omitEnd: true,
        arrows: false,
        flickPower: 120,
    });

    var donateMenu = document.querySelector('#donate-mega-menu');
    var donateMenuButtons = document.querySelectorAll('#main-nav .donate-tile');
    donateMenuButtons.forEach(function (donateMenuButton) {
        donateMenuButton.addEventListener('click', function () {
            if (donateMenu.classList.contains('d-none')) {
                var mobileMenuParent = document.querySelector('#mobile-menu');
                if (mobileMenuParent && !mobileMenuParent.classList.contains('d-none')) {
                    mobileMenuParent.classList.add('d-none');

                    var mobileMenuToggler = document.querySelector('#mobile-menu-toggle');
                    mobileMenuToggler.classList.remove('open');
                }

                donateMenu.classList.remove('d-none');
                donationCampaignsSlider.mount();
            } else {
                donateMenu.classList.add('d-none');
                donationCampaignsSlider.destroy();
            }
        });
    });

    /* Mobile menu */

    var mobileMenuToggler = document.querySelector('#mobile-menu-toggle');
    if (mobileMenuToggler) {
        mobileMenuToggler.addEventListener('click', function () {
            var mobileMenuParent = document.querySelector('#mobile-menu');
            if (mobileMenuParent) {
                if (mobileMenuParent.classList.contains('d-none')) {
                    mobileMenuParent.classList.remove('d-none');
                    mobileMenuParent.classList.add('d-flex');
                    mobileMenuToggler.classList.add('open');

                    // Close the donate mega menu, if it is open.
                    var donateMenu = document.querySelector('#donate-mega-menu');
                    if (donateMenu && !donateMenu.classList.contains('d-none')) {
                        donateMenu.classList.add('d-none');
                        donationCampaignsSlider.destroy();
                    }
                } else {
                    mobileMenuParent.classList.add('d-none');
                    mobileMenuParent.classList.remove('d-flex');
                    mobileMenuToggler.classList.remove('open');
                }
            }
        });
    }

    /* Splide sliders in blocks/flexible-page-slider-section */

    var flexiblePageSliders = document.querySelectorAll('[id^="flexible-parent-slider-section-"]');
    flexiblePageSliders.forEach(function (slideParentElement) {
        var flexiblePageSlider = new Splide(slideParentElement, {
            type: 'fade',
            perPage: 1,
            focus: 0,
            autoplay: true,
            rewind: true,
            interval: 5000,
            omitEnd: true,
            arrows: false,
            flickPower: 120
        });

        flexiblePageSlider.mount();
    });

    /* Splide slider in blocks/our-impact-section */

    var ourImpactSliderElement = document.querySelector('.our-impact-slider.splide');
    if (ourImpactSliderElement) {
        var ourImpactSlider = new Splide('.our-impact-slider.splide', {
            perPage: 4,
            focus: 0,
            omitEnd: true,
            arrows: false,
            flickPower: 120,
            breakpoints: {
                1200: {
                    perPage: 3
                },
                992: {
                    perPage: 2
                },
                768: {
                    perPage: 1
                }
            }
        });

        ourImpactSlider.mount();

        var ourImpactSliderPreviousArrow = document.querySelector('#our-impact-slider-previous');
        if (ourImpactSliderPreviousArrow) {
            ourImpactSliderPreviousArrow.addEventListener('click', function () {
                ourImpactSlider.go('<');
            });
        }

        var ourImpactSliderNextArrow = document.querySelector('#our-impact-slider-next');
        if (ourImpactSliderNextArrow) {
            ourImpactSliderNextArrow.addEventListener('click', function () {
                ourImpactSlider.go('>');
            });
        }
    }
});